<template>
    <div>
        <PlotCard
            v-if="visible && (screenProperties.isLargeScreen || (screenProperties.isMediumScreen && !screenProperties.isSmallScreen && !screenProperties.isTinyScreen))"
            ref="popup"
            class="popup"
            :class="[activeClass]"
            :data="data"
            :top="cursor"
            :arrowPosition="arrowPosition"
            :screenProperties="screenProperties"
            :style="{
                'top': top + 'px',
                'left': left + 'px'
            }"
            :type="popupType"
            :width="cardWidth"
            @close-popup="closePopup"
            @update-widget="updateWidget"
        />

        <v-dialog
            v-else-if="visible && popupDialog"
            v-model="popupDialog"
            :width="cardWidth"
        >
            <PlotCard
                ref="popup"
                class="plot-dialog"
                :data="data"
                :screenProperties="screenProperties"
                :type="popupType"
                :width="cardWidth"
                @close-popup="closePopup"
                @update-widget="updateWidget"
            />
        </v-dialog>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    import PlotCard from "@/components/plotInformation/PlotCard";

    export default {
        name: 'PopupInformation',
        components: {
            PlotCard
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            target: {
                type: HTMLDivElement,
                required: false
            },
            update: {
                type: Function,
                required: false
            },
            popupType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                visible: false,
                activeClass: '',
                popupDialog: false,
                updatePosition: false,
                arrowPosition: null,
                left: 0,
                top: 0,
                cursor: 0
            }
        },
        computed: {
            ...mapGetters([
                'isAlternativeMode',
            ]),
            cardWidth() {
                return this.isLandscapeCard ? 350 : 280;
            },
            isLandscapeCard() {
                return (this.screenProperties.isMediumScreen && !this.screenProperties.isPortrait) || (this.screenProperties.isLandscape && !this.screenProperties.isLargeScreen);
            },
            showDialog() {
                return this.screenProperties.isSmallScreen || this.screenProperties.isTinyScreen ? true : false;
            },
            screenProperties() {
                return {
                    'isTinyScreen': window.matchMedia("(orientation: portrait)").matches ? (this.$vuetify.breakpoint.width < 375 && this.$vuetify.breakpoint.height < 667 ? true : false) : (this.$vuetify.breakpoint.width < 667 && this.$vuetify.breakpoint.height < 375 ? true : false),
                    'isSmallScreen': this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.height < 1024,
                    'isMediumScreen': this.$vuetify.breakpoint.smAndUp && this.$vuetify.breakpoint.mdAndDown ? true : false,
                    'isLargeScreen': this.$vuetify.breakpoint.lgAndUp,
                    'isPortrait': window.matchMedia("(orientation: portrait)").matches,
                    'isLandscape': window.matchMedia("(orientation: landscape)").matches
                };
            }
        },
        mounted() {
            window.addEventListener('mousemove', this.getMousePosition);
            window.addEventListener("click", this.getMousePosition);
            window.addEventListener('resize', this.closePopup);
        },
        destroyed: function() {
            window.removeEventListener('mousemove', this.mouseIsMoving);
        },
        methods: {
            getMousePosition(event) {
                if (this.updatePosition && this.$refs.popup) {
                    let popupHeight = this.$refs.popup.$el.clientHeight;
                    this.left = this.data.x + (this.cardWidth / 2) + 20;
                    this.top = event.clientY;
                    this.cursor = popupHeight / 2;

                    let hasSidebar = document.getElementById('sidebar') ? true : false;
                    let isOpenedSidebar = hasSidebar ? document.getElementById('fullScreen').classList.contains('openedSidebar') : false;

                    let isTopOverflow = popupHeight - this.top >= (popupHeight / 2);
                    let isBottomOverflow = (popupHeight / 2) + this.top > window.innerHeight;
                    let isRightOverflow = this.data.x + this.cardWidth >= window.innerWidth;

                    this.top = !isBottomOverflow ? this.top : window.innerHeight - (popupHeight / 2);
                    this.top = isTopOverflow ? (popupHeight / 2) + 20 : this.top;

                    this.left = isRightOverflow ? this.data.x - (this.cardWidth / 2) - 20 : this.left;
                    if (this.popupType === 'plot' && isOpenedSidebar)
                        this.left -= document.getElementById('sidebar').offsetWidth;

                    this.arrowPosition = isRightOverflow ? 'right' : 'left';
                    this.arrowPosition += this.isLandscapeCard ? ' landscape': ' portrait';

                    this.cursor = isTopOverflow ?  event.pageY - 20 : popupHeight / 2;
                    this.cursor = isBottomOverflow ? (popupHeight / 2) + ((event.pageY + (popupHeight / 2)) - window.innerHeight) : this.cursor;
                    // console.log(
                        // {
                            // 'currentX': event.clientX,
                            // 'currentY': event.clientY,
                            // 'x': this.data.x,
                            // 'y': this.data.y,
                            // 'left': this.left,
                            // 'top': this.top,
                            // 'cursor': this.cursor,
                            // 'screenWidth': window.innerWidth,
                            // 'screenHeight': window.innerHeight,
                            // 'rightOverflow': isRightOverflow,
                            // 'topOverflow': isTopOverflow,
                            // 'bottomOverflow': isBottomOverflow
                        // }
                    // );
                    this.updatePosition = false;
                }
            },
            togglePopup() {
                this.activeClass = '';
                if (Object.keys(this.$props.data).length > 5)
                    this.visible = true;
                else
                    this.visible = false;

                if (this.visible && !this.showDialog) {
                    this.$nextTick(() => this.activeClass = 'visible');
                } else if (this.visible && this.showDialog)
                    this.popupDialog = true;
            },
            closePopup() {
                this.visible = false;
                this.popupDialog = false;
            },
            updateWidget(item) {
                this.$props.update(item);
                this.closePopup();
                if (this.isAlternativeMode)
                    EventBus.$emit('closeSidebar');
            }
        },
        watch: {
            data() {
                this.updatePosition = true;
                this.togglePopup();
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    @import "@/assets/scss/components/_popup.scss";
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/PopupInformation.vue